@custom-media --mobile (max-width: 768px);

.startSurveySection {
  background-color: #e7f2f7;

  & > div {
    padding-bottom: 3rem;
  }

  & h2 {
    margin-top: 1rem;
  }
}

.content {
  & h1 {
    margin-top: 2rem;
  }

  & h2 {
    margin-bottom: 1rem;
    margin-top: 3rem;
  }

  & h2:first-child {
    margin-top: 1rem;
  }
}

.container {
  & .content {
    padding-bottom: 1rem;
  }

  & .content:last-child {
    padding-bottom: 4rem;
  }
}

.intro {
  margin-bottom: 3.15em;
}

.description {
  & h3 {
    font-size: 1.25em;
    margin-bottom: 1.25em;
  }
}

ol.instructions {
  list-style: none;
  counter-reset: item;

  & li {
    counter-increment: item;
    background-repeat: no-repeat;
    min-height: 95px;
    padding-left: 125px;
    margin-bottom: 1.5rem;
    position: relative;
  }

  & li:nth-child(1) {
    background-image: url('../../images/instructions-icon-1.svg');
  }

  & li:nth-child(2) {
    background-image: url('../../images/instructions-icon-2.svg');
  }

  & li:nth-child(3) {
    background-image: url('../../images/instructions-icon-3.svg');
  }

  & li::before {
    content: counter(item) ". ";
    font-size: 1.5rem;
    font-weight: 600;
    position: absolute;
    text-align: right;
    left: 100px;
  }

  & h3 {
    font-size: 1.5rem;
    font-weight: 600;
    display: inline-block;
    margin-bottom: 0.5rem;
  }
}

@media (--mobile) {
  .content {
    margin-left: 0;
  }
}
